import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-history-reviews",
  "use": "foquz-icon-history-reviews-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-history-reviews\"><path d=\"M16.5 1h-13C2.121 1 1 2.142 1 3.546v8.908C1 13.858 2.121 15 3.5 15H7v3.521c0 .39.438.617.746.386L13 15h3.5c1.379 0 2.5-1.142 2.5-2.546V3.546C19 2.142 17.879 1 16.5 1z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol